import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';
import { BiaImpactConfigurationResponseSchema } from '@repo/contracts';

export class BiaImpactConfigurationService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getBiaImpactConfiguration() {
        try {
            const response = await withRetry(
                () => this.api.getBiaImpactConfiguration(),
                { maxRetries: 2 },
            );
            const validated = BiaImpactConfigurationResponseSchema.parse(response);
            return {
                success: true,
                data: validated.data,
                message: validated.message || 'BIA impact yapılandırması getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch BIA impact configuration');
        }
    }

    async updateBiaImpactConfiguration(data) {
        try {
            const response = await this.api.updateBiaImpactConfiguration(data);
            const validated = BiaImpactConfigurationResponseSchema.parse(response);
            return {
                success: true,
                data: validated.data,
                message: validated.message || 'BIA impact yapılandırması güncellendi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update BIA impact configuration');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
